{
    "title": {
        "bannerSubscriptionRenovation": "Banner de Abono renovación",
        "homePage": "Página de inicio",
        "gift": "Regalar ABONOTEATRO",
        "buy": "Comprar ABONOTEATRO",
        "register": "Registro",
        "purchaseConfirmation": "Confirmación de compra",
        "nonSubscriberQuestions": "Consultas de no abonados",
        "nonSubscriberAnswers": "Respuestas a consultas de no abonados",
        "cart": "Comprar ABONOTEATRO  (Realizar compra) ",
        "legalConditions": "Condiciones generales",
        "legalPrivacy": "Política privacidad",
        "legalCookies": "Política de cookies",
        "legalNotice": "Aviso legal",
        "faqs": "FAQs"
    }
}
